module.exports = __webpack_public_path__ + "img/img_on@3x.b08d8d7c.png";